module.exports = __webpack_public_path__ + "img/search-alb.5c1a95c9.svg";